var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C9F3E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.625C23.5 14.7962 23.1708 14.0013 22.5847 13.4153C21.9987 12.8292 21.2038 12.5 20.375 12.5H13.125C12.2962 12.5 11.5013 12.8292 10.9153 13.4153C10.3292 14.0013 10 14.7962 10 15.625V24.375C10 25.2038 10.3292 25.9987 10.9153 26.5847C11.5013 27.1708 12.2962 27.5 13.125 27.5H20.375C21.2038 27.5 21.9987 27.1708 22.5847 26.5847C23.1708 25.9987 23.5 25.2038 23.5 24.375V15.625ZM24.5 22.766L27.9805 25.484C28.8015 26.125 30 25.54 30 24.499V15.5015C30 14.46 28.8015 13.8755 27.9805 14.5165L24.5 17.234V22.766Z",
    fill: "#00B680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/VideoCallIcon.e1ee512a05dec8f2dbe4f669ed6c80f8.svg";
export { ForwardRef as ReactComponent };